export default __webpack_public_path__ + "assets/media/04a62898c9d2ced28148629e374b65c1.mp3";